import { QueryClient } from "@tanstack/react-query";

/**
 * Shared cache for remote application state.
 *
 * Most merchant data changes only after an explicit mutation or an SSE event,
 * so a short stale window prevents duplicate requests when sibling components
 * consume the same resource without leaving data stale for long.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
    mutations: {
      retry: false,
    },
  },
});
